import { signoutUser } from '@/composables/auth'
import { getUserData } from '@/composables/user'
import { i18nGlobal } from '@/i18n'
import { useStoreAuth } from '@/stores/storeAuth'
import { useStoreUser } from '@/stores/storeUser'
import loggerLocal from '@/utils/loggerLocal'
import { showErrorMessage } from '@/utils/showMessage'
import { getAuth, getIdToken, onAuthStateChanged } from 'firebase/auth'
import { defineAsyncComponent, type DefineComponent } from 'vue'
/*type Loader = () => Promise<any>

export function AsyncPage ( loader: Loader ): DefineComponent {
    return defineAsyncComponent( {
        loader,
        suspensible: false,     // evita sospensioni con <Suspense> se non lo usi
        timeout: 20000,         // 20s
        onError ( error, retry, fail, attempts ) {
            const msg = String( ( error as any )?.message ?? error )

            const isChunkError =
                /ChunkLoadError/i.test( msg ) ||
                /Loading chunk \d+ failed/i.test( msg ) ||
                /Failed to fetch dynamically imported module/i.test( msg ) ||
                /Importing a module script failed/i.test( msg ) ||
                /NetworkError|Failed to fetch/i.test( msg )

            // fino a 3 tentativi di retry su errori transitori
            if ( isChunkError && attempts <= 3 )
            {
                retry()
                return
            }

            // altrimenti fallisci (senza argomenti)
            fail()
        },
    } )
}*/
type Loader<T = any> = () => Promise<T>;

function isChunkError ( err: unknown ): boolean {
    const msg = String( ( err as any )?.message ?? err );
    return (
        /ChunkLoadError/i.test( msg ) ||
        /Loading chunk \d+ failed/i.test( msg ) ||
        /Failed to fetch dynamically imported module/i.test( msg ) ||
        /Importing a module script failed/i.test( msg ) ||
        /NetworkError|Failed to fetch/i.test( msg )
    );
}

/**
 * Ritorna una funzione compatibile con Vue Router: () => import('...'),
 * ma con retry automatico su errori di chunk/rete.
 */
export function lazyWithRetry<T> (
    loader: Loader<T>,
    retries = 3,
    delayMs = 500
): () => Promise<T> {
    const attempt = ( n: number ): Promise<T> =>
        loader().catch( ( err ) => {
            if ( n > 0 && isChunkError( err ) )
            {
                return new Promise<T>( ( resolve, reject ) => {
                    setTimeout( () => {
                        attempt( n - 1 ).then( resolve ).catch( reject );
                    }, delayMs );
                } );
            }
            throw err;
        } );

    return () => attempt( retries );
}


export async function initUserData () {
    const functionName = 'initUserData'
    const storeAuth = useStoreAuth()
    const storeUser = useStoreUser()

    if ( ( storeAuth.user == null || storeUser.userData == null || storeUser.userData.id == null ) && !storeUser.fetching )
    {
        const res = await getUserData()
        if ( !res || res.isRegistered == false )
        {
            loggerLocal.error( 'Utente non registrato' )
            //const storeError = useStoreError()
            //storeError.setError(i18nGlobal.t('error.initUserDataError') + ' ' + functionName, res)
            showErrorMessage( i18nGlobal.t( 'error.initUserDataError' ) + ' ' + functionName, res )
            await signoutUser()
            return false
        } else
        {
            loggerLocal.info( functionName, ' user data stored in storeUser' )
        }
    }

    return true
}

export async function waitForFirebaseUser (): Promise<string | undefined> {
    const auth = getAuth();

    if ( auth.currentUser )
    {
        return getIdToken( auth.currentUser );
    }

    return new Promise( ( resolve ) => {
        const unsubscribe = onAuthStateChanged( auth, async ( user ) => {
            unsubscribe();
            if ( user )
            {
                const token = await getIdToken( user );
                resolve( token );
            } else
            {
                resolve( undefined );
            }
        } );
    } );
}